<template>
  <div>
    <form role="form" @submit.stop.prevent="onSubmit">
      <vs-alert
        v-if="$validator.errors.all().length > 0"
        color="danger"
        title="Atenção!!"
        active="true"
        class="my-3"
        style="height: auto !important"
      >
        <ul>
          <li
            class="mb-2"
            v-for="error in $validator.errors.all()"
            :key="error.id"
          >
            {{ error }}
          </li>
        </ul>
      </vs-alert>
      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/1 w-full">
          <span>Nome do Status</span>
          <vs-input
            size="large"
            class="w-full"
            name="Nome"
            id="Nome"
            v-model="formCadastro.nomeStatus"
            v-validate="{ required: true, min: 3 }"
            :state="validateState('Nome')"
            :danger="validateClass('Nome')"
            val-icon-danger="clear"
            danger-text="Preencha este Campo"
          />
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full text-right">
          <vs-button color="success" class="mr-3 mb-2">Adicionar</vs-button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import * as lang from 'vuejs-datepicker/src/locale';
import service from '../../../../services';

export default {
  props: ['tipo', 'idEmpresa'],
  watch: {},
  data() {
    return {
      aguardeCadastro: false,
      languages: lang,
      funcoesValicao: null,
      formCadastro: {
        idEmpresa: null,
        tipoStatus: null,
        nomeStatus: null,
      },
    };
  },
  methods: {
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
    validateClass(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return this.veeErrors.has(ref);
      }
      return null;
    },

    onSubmit() {
      this.formCadastro.idEmpresa = this.idEmpresa;
      this.formCadastro.tipoStatus = this.tipo;

      var action = 'Adicionar';

      console.log(this.formCadastro);
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.aguardeCadastro = true;
          service
            .post('status', action, this.formCadastro)
            .then((res) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: `Operação Realizada com sucesso`,
                color: 'success',
              });
              this.$emit('add', res.data);
              this.formCadastro.nomeStatus = '';
            })
            .catch((error) => {
              this.aguardeCadastro = false;
              this.$vs.notify({
                position: 'top-center',
                title: 'Atenção',
                text: error,
                color: 'danger',
              });
            });
        }
      });
    },
  },
};
</script>
